import { FaDownload } from "react-icons/fa";
import { useFiles } from "../../../../hooks/useFiles";
import styles from "../../css/messages.module.css";

export const ImageModal = ({ imageURL, imageName, setShowImageModal }) => {
  const { handleDownload } = useFiles();

  return (
    <div
      className={styles.imageModalOverlay}
      onClick={() => setShowImageModal(false)}
    >
      <div
        className={styles.imageModalContent}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Download button at top left */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleDownload(imageURL, imageName);
          }}
          className={styles.modalDownloadButton}
          title="Download"
        >
          <FaDownload />
        </button>

        <img src={imageURL} alt="Preview" className={styles.fullImage} />
      </div>
    </div>
  );
};
